const participantRole = {
  requesting: 0,
  contested: 1
};

module.exports = participantRole;
